<template>
  <div class="my-life-page">
    <!-- Móvil: barra fija compacta (estilo weeks.ginatrapani.org) -->
    <div
      ref="topbarEl"
      class="my-life-topbar d-md-none"
      :class="{
        'my-life-topbar--scrolled': topbarScrolled,
        'my-life-topbar--selection': panelActivo === 'mapa' && selectedBox,
        'my-life-topbar--editing': editingBoxKey
      }"
      :style="{ top: topbarTopPx + 'px' }"
    >
      <div
        v-if="panelActivo === 'mapa' && selectedBox"
        class="my-life-topbar-date-banner"
      >
        <span class="my-life-topbar-date-label">{{ formatDisplayDate(selectedBox.date) }}</span>
      </div>
      <div class="my-life-topbar-row">
        <h1 class="my-life-topbar-title mb-0">My Life</h1>
        <div class="my-life-topbar-tabs" role="tablist">
          <button
            type="button"
            class="my-life-tab"
            :class="{ active: panelActivo === 'mapa' }"
            @click="panelActivo = 'mapa'"
          >Mapa</button>
          <button
            type="button"
            class="my-life-tab"
            :class="{ active: panelActivo === 'leyenda' }"
            @click="panelActivo = 'leyenda'"
          >Colores</button>
          <button
            type="button"
            class="my-life-tab"
            :class="{ active: panelActivo === 'ajustes' }"
            @click="panelActivo = 'ajustes'"
          >Ajustes</button>
        </div>
        <button
          type="button"
          class="btn btn-success btn-sm my-life-save-btn"
          @click="guardar"
          :disabled="guardando || !birthDate"
          title="Guardar"
        >
          <span v-if="guardando" class="spinner-border spinner-border-sm"></span>
          <span v-else>Guardar</span>
        </button>
      </div>

      <nav
        v-if="panelActivo === 'mapa' && topbarScrolled && !selectedBox && boxStream.decades.length"
        class="my-life-topbar-decades"
        aria-label="Saltar por décadas"
      >
        <a
          v-for="dec in boxStream.decades"
          :key="'top-' + dec.age"
          href="#"
          class="my-life-decade-link"
          @click.prevent="scrollToDecade(dec)"
        >{{ decadeNavLabel(dec.age) }}</a>
      </nav>

      <div
        v-if="panelActivo === 'mapa' && selectedBox"
        class="my-life-topbar-selection"
      >
        <select v-model="paintLivingId" class="form-select form-select-sm my-life-topbar-select">
          <option v-for="l in data.living" :key="l.id" :value="l.id">{{ l.label }}</option>
        </select>
        <select v-model="paintDoingId" class="form-select form-select-sm my-life-topbar-select">
          <option v-for="d in data.doing" :key="d.id" :value="d.id">{{ d.label }}</option>
        </select>
        <button type="button" class="btn btn-dark btn-sm py-0 px-2" @click="pintarDesdeSeleccion">Pintar</button>
        <button type="button" class="btn btn-link btn-sm py-0 px-1" @click="selectedBox = null">×</button>
      </div>

      <div v-if="mensaje" class="my-life-topbar-flash success">{{ mensaje }}</div>
      <div v-if="error" class="my-life-topbar-flash danger">{{ error }}</div>
    </div>
    <div
      class="my-life-topbar-spacer d-md-none"
      :style="{ height: topbarSpacerPx + 'px' }"
      aria-hidden="true"
    ></div>

    <div class="container-fluid py-3 py-md-4">
      <header class="my-life-desktop-header d-none d-md-block">
        <div class="d-flex flex-wrap align-items-center gap-2 mb-3">
          <h1 class="my-life-title mb-0">My Life</h1>
          <span class="text-muted small">Tu vida en semanas</span>
          <div class="ms-auto d-flex gap-2 flex-wrap">
            <button
              type="button"
              class="btn btn-sm"
              :class="panelActivo === 'mapa' ? 'btn-dark' : 'btn-outline-secondary'"
              @click="panelActivo = 'mapa'"
            >
              Mapa
            </button>
            <button
              type="button"
              class="btn btn-sm"
              :class="panelActivo === 'leyenda' ? 'btn-dark' : 'btn-outline-secondary'"
              @click="panelActivo = 'leyenda'"
            >
              Colores
            </button>
            <button
              type="button"
              class="btn btn-sm"
              :class="panelActivo === 'ajustes' ? 'btn-dark' : 'btn-outline-secondary'"
              @click="panelActivo = 'ajustes'"
            >
              Ajustes
            </button>
            <button class="btn btn-sm btn-success" @click="guardar" :disabled="guardando || !birthDate">
              <span v-if="guardando" class="spinner-border spinner-border-sm me-1"></span>
              Guardar
            </button>
          </div>
        </div>

        <div v-if="mensaje" class="alert alert-success py-2">{{ mensaje }}</div>
        <div v-if="error" class="alert alert-danger py-2">{{ error }}</div>
      </header>

      <div v-if="cargando" class="text-center py-5">
        <div class="spinner-border text-secondary"></div>
      </div>

      <template v-else>
        <!-- Leyenda / colores -->
        <div v-show="panelActivo === 'leyenda'" class="card border-0 shadow-sm mb-4">
          <div class="card-body">
            <p class="small text-muted mb-3">
              El <strong>borde</strong> de cada casilla es dónde vivías; el <strong>fondo</strong>, qué hacías.
              Puedes cambiar colores desde aquí o pintar desde una casilla seleccionada en el mapa.
            </p>
            <div class="row g-3">
              <div class="col-md-6">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <strong class="small">Dónde (borde)</strong>
                  <button type="button" class="btn btn-sm btn-outline-secondary" @click="addLiving">+</button>
                </div>
                <div v-for="(item, idx) in data.living" :key="item.id" class="d-flex gap-2 mb-2 align-items-center">
                  <input type="color" v-model="item.color" class="form-control form-control-color flex-shrink-0" />
                  <input v-model="item.label" type="text" class="form-control form-control-sm" />
                  <button
                    v-if="data.living.length > 1"
                    type="button"
                    class="btn btn-sm btn-outline-danger"
                    @click="removeLiving(idx)"
                  >×</button>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <strong class="small">Qué hacía (fondo)</strong>
                  <button type="button" class="btn btn-sm btn-outline-secondary" @click="addDoing">+</button>
                </div>
                <div v-for="(item, idx) in data.doing" :key="item.id" class="d-flex gap-2 mb-2 align-items-center">
                  <input type="color" v-model="item.color" class="form-control form-control-color flex-shrink-0" />
                  <input v-model="item.label" type="text" class="form-control form-control-sm" />
                  <button
                    v-if="data.doing.length > 1"
                    type="button"
                    class="btn btn-sm btn-outline-danger"
                    @click="removeDoing(idx)"
                  >×</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Ajustes -->
        <div v-show="panelActivo === 'ajustes'" class="card border-0 shadow-sm mb-4">
          <div class="card-body">
            <div class="row g-3">
              <div class="col-sm-6 col-md-4">
                <label class="form-label">Fecha de nacimiento</label>
                <input v-model="birthDate" type="date" class="form-control" required />
              </div>
              <div class="col-sm-6 col-md-4">
                <label class="form-label">Esperanza de vida (años)</label>
                <input v-model.number="expectancyYears" type="number" min="1" max="120" class="form-control" />
              </div>
            </div>
            <p class="small text-muted mt-3 mb-0">
              Compartir enlace público — próximamente.
            </p>
          </div>
        </div>

        <!-- Mapa -->
        <div v-show="panelActivo === 'mapa'">
          <div v-if="!birthDate" class="alert alert-warning">
            Indica tu fecha de nacimiento en <strong>Ajustes</strong>.
          </div>

          <template v-else>
            <p class="my-life-intro small d-none d-md-block">
              Escribe directamente en las casillas. Cada año empieza con tu edad (🎂).
              Toca una casilla vacía para añadir texto; en Colores cambias dónde y qué hacías.
            </p>

            <!-- Barra pintar (casilla seleccionada) -->
            <div v-if="selectedBox" class="paint-bar card border-0 shadow-sm mb-3 d-none d-md-block">
              <div class="card-body py-2 d-flex flex-wrap gap-2 align-items-center">
                <span class="small text-muted fw-semibold">{{ formatDisplayDate(selectedBox.date) }}</span>
                <select v-model="paintLivingId" class="form-select form-select-sm" style="max-width: 9rem;">
                  <option v-for="l in data.living" :key="l.id" :value="l.id">{{ l.label }}</option>
                </select>
                <select v-model="paintDoingId" class="form-select form-select-sm" style="max-width: 9rem;">
                  <option v-for="d in data.doing" :key="d.id" :value="d.id">{{ d.label }}</option>
                </select>
                <button type="button" class="btn btn-sm btn-dark" @click="pintarDesdeSeleccion">
                  Pintar colores desde aquí
                </button>
                <button type="button" class="btn btn-sm btn-link" @click="selectedBox = null">Cerrar</button>
              </div>
            </div>

            <!-- Navegación décadas -->
            <nav v-if="boxStream.decades.length" class="decade-nav mb-3 d-none d-md-flex flex-wrap gap-2">
              <a
                v-for="dec in boxStream.decades"
                :key="'nav-' + dec.age"
                href="#"
                class="badge rounded-pill text-decoration-none decade-pill"
                @click.prevent="scrollToDecade(dec)"
              >
                {{ dec.age }} años
              </a>
            </nav>

            <div class="life-in-weeks" ref="mapEl">
              <div class="life-boxes-flow">
                <template v-for="box in boxStream.boxes" :key="box.key">
                  <div
                    v-if="decadeMarkerAt(box.key)"
                    :id="'decade-' + decadeMarkerAt(box.key).age"
                    class="decade-anchor"
                    :data-age="decadeMarkerAt(box.key).age"
                  ></div>

                  <div
                    class="life-box"
                    :class="boxClasses(box)"
                    :style="boxStyles(box)"
                    v-bind="boxTooltipAttrs(box)"
                    :data-box-key="box.key"
                    @click="onBoxClick(box)"
                  >
                    <input
                      v-if="boxNeedsInput(box)"
                      :ref="(el) => setBoxInputRef(box.key, el)"
                      type="text"
                      class="life-box-field"
                      :value="box.headline"
                      :readonly="box.inFuture"
                      @focus="onBoxFocus(box)"
                      @blur="onBoxBlur(box, $event)"
                      @keydown.enter.prevent="$event.target.blur()"
                    />
                  </div>
                </template>
              </div>
            </div>

            <!-- Descripción de casilla activa -->
            <div v-if="selectedBox" class="card border-0 shadow-sm mt-3">
              <div class="card-body py-3">
                <label class="form-label small mb-1">Notas (opcional)</label>
                <textarea
                  class="form-control form-control-sm"
                  rows="2"
                  :value="entryDescription(selectedBox.date)"
                  placeholder="Más detalle sobre esta semana o evento…"
                  @change="onDescriptionChange(selectedBox, $event)"
                ></textarea>
              </div>
            </div>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue';
import axios from '../config/axios';
import * as bootstrap from 'bootstrap';
import {
  parseISODate,
  buildLifeBoxStream,
  entriesFromLegacy,
  upsertEntry,
  defaultBirthdayHeadline,
  formatDisplayDate
} from '../utils/myLifeWeeks';

function slugId(label) {
  return String(label || 'item')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '') || 'item';
}

function uid() {
  return Math.random().toString(36).slice(2, 12);
}

export default {
  name: 'MyLifeView',
  setup() {
    const cargando = ref(true);
    const guardando = ref(false);
    const error = ref('');
    const mensaje = ref('');
    const panelActivo = ref('mapa');
    const birthDate = ref('');
    const expectancyYears = ref(90);
    const mapEl = ref(null);
    const topbarEl = ref(null);
    const topbarScrolled = ref(false);
    const topbarTopPx = ref(0);
    const topbarSpacerPx = ref(56);
    const editingBoxKey = ref(null);
    const selectedBox = ref(null);
    const paintLivingId = ref('casa');
    const paintDoingId = ref('infancia');
    const boxInputRefs = ref({});
    const tooltipByEl = new WeakMap();

    const data = ref({
      living: [
        { id: 'casa', label: 'En casa', color: '#8eb2d6' },
        { id: 'viajes', label: 'Viajando', color: '#FCC737' }
      ],
      doing: [
        { id: 'infancia', label: 'Infancia', color: '#FFF6DA' },
        { id: 'estudiante', label: 'Estudiante', color: '#E8F9FF' },
        { id: 'trabajando', label: 'Trabajando', color: '#F8E7F6' }
      ],
      periods: [{ startDate: null, livingId: 'casa', doingId: 'infancia', note: '' }],
      entries: []
    });

    const birthDateParsed = computed(() => parseISODate(birthDate.value));

    const livingMap = computed(() => {
      const m = {};
      data.value.living.forEach((l) => { m[l.id] = l; });
      return m;
    });

    const doingMap = computed(() => {
      const m = {};
      data.value.doing.forEach((d) => { m[d.id] = d; });
      return m;
    });

    const boxStream = computed(() => {
      if (!birthDateParsed.value) return { boxes: [], decades: [] };
      return buildLifeBoxStream(
        birthDateParsed.value,
        expectancyYears.value || 90,
        data.value.periods,
        data.value.entries
      );
    });

    const decadeByBoxKey = computed(() => {
      const m = {};
      boxStream.value.decades.forEach((d) => {
        const box = boxStream.value.boxes[d.boxIndex];
        if (box) m[box.key] = d;
      });
      return m;
    });

    function decadeMarkerAt(boxKey) {
      return decadeByBoxKey.value[boxKey] || null;
    }

    function boxStyles(box) {
      const living = livingMap.value[box.livingId] || data.value.living[0];
      const doing = doingMap.value[box.doingId] || data.value.doing[0];
      return {
        borderColor: living?.color || '#dee2e6',
        backgroundColor: doing?.color || '#fff'
      };
    }

    function boxClasses(box) {
      return {
        'life-box--birthday': box.type === 'birthday',
        'life-box--event': box.type === 'event',
        'life-box--week': box.type === 'week',
        'life-box--empty': box.type === 'week' && !box.headline,
        'life-box--future': box.inFuture,
        'life-box--current': box.isCurrent,
        'life-box--selected': selectedBox.value?.key === box.key
      };
    }

    function boxNeedsInput(box) {
      if (box.type === 'birthday' || box.type === 'event') return true;
      if (box.headline) return true;
      return selectedBox.value?.key === box.key;
    }

    function boxTooltipTitle(box) {
      const dateStr = formatDisplayDate(box.date);
      const living = livingMap.value[box.livingId]?.label || '';
      const doing = doingMap.value[box.doingId]?.label || '';
      if (box.type === 'birthday') {
        const yearsWord = box.age === 1 ? 'año' : 'años';
        return `${dateStr} – ${box.age} ${yearsWord}`;
      }
      const desc = box.description?.trim();
      if (desc) return `${dateStr} – ${desc}`;
      const headline = box.headline?.trim();
      if (headline) return `${dateStr} – ${headline}`;
      return `${dateStr} – ${doing}${living ? `, en ${living}` : ''}`;
    }

    function boxTooltipAttrs(box) {
      if (box.inFuture || selectedBox.value?.key === box.key) return {};
      return {
        'data-bs-toggle': 'tooltip',
        'data-bs-placement': 'bottom',
        'data-bs-custom-class': 'my-life-custom-tooltip',
        'data-bs-title': boxTooltipTitle(box)
      };
    }

    function disposeTooltips() {
      if (!mapEl.value) return;
      mapEl.value.querySelectorAll('.life-box').forEach((el) => {
        const instance = tooltipByEl.get(el) || bootstrap.Tooltip.getInstance(el);
        if (instance) {
          instance.dispose();
          tooltipByEl.delete(el);
        }
      });
    }

    function initTooltips() {
      disposeTooltips();
      if (!mapEl.value || cargando.value) return;
      nextTick(() => {
        const isTouch = window.matchMedia('(hover: none)').matches;
        mapEl.value.querySelectorAll('.life-box').forEach((el) => {
          if (el.classList.contains('life-box--future')) return;
          if (el.classList.contains('life-box--selected')) return;
          const key = el.getAttribute('data-box-key');
          const box = boxStream.value.boxes.find((b) => b.key === key);
          if (!box) return;
          const instance = new bootstrap.Tooltip(el, {
            placement: 'bottom',
            customClass: 'my-life-custom-tooltip',
            trigger: isTouch ? 'focus click' : 'hover focus',
            container: 'body'
          });
          tooltipByEl.set(el, instance);
        });
      });
    }

    function setBoxInputRef(key, el) {
      if (el) boxInputRefs.value[key] = el;
    }

    function onBoxClick(box) {
      if (box.inFuture) return;
      disposeTooltips();
      selectedBox.value = box;
      paintLivingId.value = box.livingId || data.value.living[0]?.id;
      paintDoingId.value = box.doingId || data.value.doing[0]?.id;
      scrollBoxIntoView(box.key);
      if (box.type === 'week' && !box.headline) {
        nextTick(() => {
          const input = boxInputRefs.value[box.key];
          input?.focus();
        });
      }
    }

    function onBoxFocus(box) {
      if (box.inFuture) return;
      selectedBox.value = box;
      editingBoxKey.value = box.key;
      paintLivingId.value = box.livingId || data.value.living[0]?.id;
      paintDoingId.value = box.doingId || data.value.doing[0]?.id;
      scrollBoxIntoView(box.key);
    }

    function onBoxBlur(box, ev) {
      if (box.inFuture) return;
      if (editingBoxKey.value === box.key) editingBoxKey.value = null;
      let headline = ev.target.value.trim();
      if (box.type === 'birthday' && !headline) {
        headline = defaultBirthdayHeadline(box.age, box.calendarYear);
        ev.target.value = headline;
      }
      data.value.entries = upsertEntry(data.value.entries, {
        date: box.date,
        headline
      });
    }

    function entryDescription(date) {
      return data.value.entries.find((e) => e.date === date)?.description || '';
    }

    function onDescriptionChange(box, ev) {
      const description = ev.target.value.trim();
      const existing = data.value.entries.find((e) => e.date === box.date);
      data.value.entries = upsertEntry(data.value.entries, {
        date: box.date,
        headline: existing?.headline || box.headline,
        description
      });
      nextTick(initTooltips);
    }

    function pintarDesdeSeleccion() {
      if (!selectedBox.value) return;
      const start = selectedBox.value.date;
      const periods = data.value.periods.filter((p) => p.startDate !== start);
      periods.push({
        startDate: start,
        livingId: paintLivingId.value,
        doingId: paintDoingId.value,
        note: ''
      });
      periods.sort((a, b) => {
        if (!a.startDate) return -1;
        if (!b.startDate) return 1;
        return a.startDate.localeCompare(b.startDate);
      });
      data.value.periods = periods;
      mensaje.value = 'Colores aplicados desde esta fecha. Guarda para persistir.';
      setTimeout(() => { mensaje.value = ''; }, 2500);
    }

    function decadeNavLabel(age) {
      if (age === 0) return 'Inicio';
      if (age % 10 !== 0) return `${age}`;
      if (age >= 100) return '100';
      return `${age}s`;
    }

    function getScrollOffset() {
      return topbarTopPx.value + topbarSpacerPx.value + 12;
    }

    function updateTopbar() {
      const nav = document.querySelector('nav.navbar');
      const navBottom = nav ? Math.round(nav.getBoundingClientRect().bottom) : 0;
      topbarTopPx.value = Math.max(0, navBottom);
      topbarScrolled.value = window.scrollY > 12;
      if (topbarEl.value) {
        topbarSpacerPx.value = topbarEl.value.offsetHeight;
      }
    }

    function scrollBoxIntoView(boxKey) {
      nextTick(() => {
        updateTopbar();
        const el = document.querySelector(`.life-box[data-box-key="${boxKey}"]`);
        if (!el) return;
        const offset = getScrollOffset();
        const y = el.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      });
    }

    function scrollToDecade(dec) {
      const el = document.getElementById(`decade-${dec.age}`);
      if (!el) return;
      const y = el.getBoundingClientRect().top + window.scrollY - getScrollOffset();
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }

    function addLiving() {
      data.value.living.push({ id: `l-${uid()}`, label: 'Nuevo lugar', color: '#a8d5ba' });
    }

    function addDoing() {
      data.value.doing.push({ id: `d-${uid()}`, label: 'Nueva etapa', color: '#e8e8ff' });
    }

    function removeLiving(idx) {
      const removed = data.value.living.splice(idx, 1)[0];
      const fallback = data.value.living[0]?.id;
      data.value.periods.forEach((p) => {
        if (p.livingId === removed.id) p.livingId = fallback;
      });
    }

    function removeDoing(idx) {
      const removed = data.value.doing.splice(idx, 1)[0];
      const fallback = data.value.doing[0]?.id;
      data.value.periods.forEach((p) => {
        if (p.doingId === removed.id) p.doingId = fallback;
      });
    }

    async function cargar() {
      cargando.value = true;
      error.value = '';
      try {
        const res = await axios.get('/api/my-life');
        birthDate.value = res.data.birth_date || '';
        expectancyYears.value = res.data.expectancy_years || 90;
        if (res.data.data) {
          const d = res.data.data;
          data.value = {
            living: d.living || data.value.living,
            doing: d.doing || data.value.doing,
            periods: d.periods || data.value.periods,
            entries: entriesFromLegacy(d)
          };
        }
        if (data.value.living.length) paintLivingId.value = data.value.living[0].id;
        if (data.value.doing.length) paintDoingId.value = data.value.doing[0].id;
      } catch (e) {
        error.value = e.response?.data?.error || 'Error al cargar My Life';
      } finally {
        cargando.value = false;
      }
    }

    async function guardar() {
      if (!birthDate.value) {
        error.value = 'Indica tu fecha de nacimiento';
        panelActivo.value = 'ajustes';
        return;
      }
      guardando.value = true;
      error.value = '';
      mensaje.value = '';
      try {
        const res = await axios.put('/api/my-life', {
          birth_date: birthDate.value,
          expectancy_years: expectancyYears.value,
          data: {
            living: data.value.living.map((l) => ({
              id: l.id || slugId(l.label),
              label: l.label,
              color: l.color
            })),
            doing: data.value.doing.map((d) => ({
              id: d.id || slugId(d.label),
              label: d.label,
              color: d.color
            })),
            periods: data.value.periods,
            entries: data.value.entries
          }
        });
        birthDate.value = res.data.birth_date || birthDate.value;
        expectancyYears.value = res.data.expectancy_years || expectancyYears.value;
        if (res.data.data) {
          data.value.entries = entriesFromLegacy(res.data.data);
          data.value.living = res.data.data.living;
          data.value.doing = res.data.data.doing;
          data.value.periods = res.data.data.periods;
        }
        mensaje.value = 'Guardado correctamente';
        setTimeout(() => { mensaje.value = ''; }, 4000);
      } catch (e) {
        error.value = e.response?.data?.error || 'Error al guardar';
      } finally {
        guardando.value = false;
      }
    }

    watch(birthDate, () => {
      selectedBox.value = null;
    });

    watch(selectedBox, (box) => {
      if (!box) editingBoxKey.value = null;
      nextTick(() => {
        updateTopbar();
        initTooltips();
      });
    });

    watch(boxStream, () => {
      if (!cargando.value) nextTick(initTooltips);
    });

    onMounted(() => {
      cargar().then(() => nextTick(initTooltips));
      updateTopbar();
      window.addEventListener('scroll', updateTopbar, { passive: true });
      window.addEventListener('resize', updateTopbar);
    });

    onUnmounted(() => {
      disposeTooltips();
      window.removeEventListener('scroll', updateTopbar);
      window.removeEventListener('resize', updateTopbar);
    });

    watch([panelActivo, selectedBox, mensaje, error, cargando], () => {
      nextTick(updateTopbar);
    });

    return {
      cargando,
      guardando,
      error,
      mensaje,
      panelActivo,
      birthDate,
      expectancyYears,
      data,
      mapEl,
      topbarEl,
      topbarScrolled,
      topbarTopPx,
      topbarSpacerPx,
      editingBoxKey,
      formatDisplayDate,
      decadeNavLabel,
      boxStream,
      selectedBox,
      paintLivingId,
      paintDoingId,
      decadeMarkerAt,
      boxStyles,
      boxClasses,
      boxNeedsInput,
      boxTooltipAttrs,
      boxTooltipTitle,
      setBoxInputRef,
      onBoxClick,
      onBoxFocus,
      onBoxBlur,
      entryDescription,
      onDescriptionChange,
      pintarDesdeSeleccion,
      scrollToDecade,
      addLiving,
      addDoing,
      removeLiving,
      removeDoing,
      guardar
    };
  }
};
</script>

<style scoped>
.my-life-page {
  --ml-bg: #fff7e9;
  --ml-text: #3f5c72;
  --ml-accent: #f05d2b;
  --ml-future-border: #dee2e6;
  --ml-future-bg: #eeeeee;
  background: var(--ml-bg);
  min-height: calc(100vh - 56px);
  color: var(--ml-text);
}

.my-life-page {
  scroll-padding-top: 4.5rem;
}

/* Móvil: barra superior fija y compacta */
.my-life-topbar {
  position: fixed;
  left: 0;
  right: 0;
  z-index: 1020;
  background: var(--ml-bg);
  border-bottom: 1px solid rgba(63, 92, 114, 0.12);
  box-shadow: 0 2px 10px rgba(63, 92, 114, 0.1);
  padding: 0.35rem 0.5rem 0.4rem;
  font-size: 0.75rem;
}


.my-life-topbar-date-banner {
  text-align: center;
  padding: 0.15rem 0.25rem 0.2rem;
  border-bottom: 1px solid rgba(63, 92, 114, 0.12);
  background: rgba(255, 255, 255, 0.55);
}

.my-life-topbar-date-label {
  font-size: 0.85rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  color: var(--ml-accent);
}

.my-life-topbar--editing .my-life-topbar-date-label {
  font-size: 0.95rem;
}

.my-life-topbar-row {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  min-height: 1.75rem;
}

.my-life-topbar-title {
  font-size: 1.35rem;
  font-weight: 800;
  line-height: 1.1;
  color: var(--ml-text);
  flex-shrink: 0;
  transition: font-size 0.2s ease;
}

.my-life-topbar--scrolled .my-life-topbar-title {
  font-size: 1rem;
}

.my-life-topbar-tabs {
  display: flex;
  flex: 1;
  min-width: 0;
  gap: 0.15rem;
  justify-content: center;
}

.my-life-tab {
  border: 1px solid rgba(63, 92, 114, 0.25);
  background: transparent;
  color: var(--ml-text);
  border-radius: 999px;
  padding: 0.1rem 0.45rem;
  font-size: 0.68rem;
  font-weight: 600;
  line-height: 1.3;
  white-space: nowrap;
}

.my-life-tab.active {
  background: var(--ml-text);
  border-color: var(--ml-text);
  color: #fff;
}

.my-life-save-btn {
  flex-shrink: 0;
  font-size: 0.68rem;
  padding: 0.15rem 0.5rem;
  line-height: 1.2;
}

.my-life-topbar-decades {
  display: flex;
  flex-wrap: nowrap;
  gap: 0.2rem;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0.25rem 0 0.1rem;
  margin-top: 0.15rem;
  scrollbar-width: none;
}

.my-life-topbar-decades::-webkit-scrollbar {
  display: none;
}

.my-life-decade-link {
  flex-shrink: 0;
  color: var(--ml-accent);
  border: 1px solid var(--ml-accent);
  border-radius: 999px;
  padding: 0.1rem 0.4rem;
  font-size: 0.65rem;
  font-weight: 600;
  text-decoration: none;
  line-height: 1.2;
}

.my-life-topbar-selection {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem;
  margin-top: 0.25rem;
  padding-top: 0.2rem;
  border-top: 1px solid rgba(63, 92, 114, 0.1);
}

.my-life-topbar-date {
  font-weight: 700;
  font-size: 0.7rem;
  color: var(--ml-text);
  flex-shrink: 0;
}

.my-life-topbar-select {
  max-width: 6.5rem;
  font-size: 0.68rem;
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
  min-height: 1.6rem;
}

.my-life-topbar-flash {
  margin-top: 0.2rem;
  padding: 0.15rem 0.4rem;
  border-radius: 4px;
  font-size: 0.68rem;
  line-height: 1.2;
}

.my-life-topbar-flash.success {
  background: #d1e7dd;
  color: #0f5132;
}

.my-life-topbar-flash.danger {
  background: #f8d7da;
  color: #842029;
}

.my-life-topbar-spacer {
  flex-shrink: 0;
}

@media (min-width: 768px) {
  .my-life-page {
    scroll-padding-top: 0;
  }
}


.my-life-title {
  font-size: 1.75rem;
  font-weight: 800;
  color: var(--ml-text);
}

@media (min-width: 768px) {
  .my-life-title {
    font-size: 2.25rem;
  }
}

.my-life-intro {
  color: var(--ml-text);
  opacity: 0.85;
}

.decade-pill {
  background: var(--ml-bg);
  color: var(--ml-accent);
  border: 1px solid var(--ml-accent);
  font-weight: 600;
  padding: 0.35em 0.75em;
}

.decade-pill:hover {
  background: var(--ml-accent);
  color: #fff;
}

.paint-bar {
  background: #fff;
}

.life-in-weeks {
  border-radius: 6px;
  padding: 0.75rem;
  background: var(--ml-bg);
}

.life-boxes-flow {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 3px;
  line-height: 1.3;
}

.decade-anchor {
  width: 100%;
  height: 0;
  flex-basis: 100%;
}

.life-box {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  border: 3px solid #ccc;
  border-radius: 3px;
  min-height: 2.25em;
  padding: 0;
  margin: 1px;
  cursor: text;
  transition: box-shadow 0.15s, transform 0.1s;
  max-width: 100%;
}

.life-box-field {
  border: none;
  background: transparent;
  color: inherit;
  font: inherit;
  font-size: inherit;
  line-height: 1.3;
  padding: 4px 8px;
  margin: 0;
  width: 100%;
  min-width: 2ch;
  outline: none;
}

.life-box-field:focus {
  outline: none;
}

.life-box--birthday,
.life-box--event {
  min-height: 2.5em;
}

.life-box--birthday .life-box-field,
.life-box--event .life-box-field {
  font-size: 0.95rem;
  white-space: nowrap;
}

.life-box--week.life-box--empty {
  width: 2.5em;
  min-width: 2.5em;
  max-width: 2.5em;
  min-height: 2.5em;
  justify-content: center;
}

.life-box--week.life-box--empty .life-box-field {
  padding: 4px 2px;
  text-align: center;
  font-size: 0.75rem;
}

.life-box--week:not(.life-box--empty) {
  min-width: 3em;
}

.life-box--future {
  background-color: var(--ml-future-bg) !important;
  border-color: var(--ml-future-border) !important;
  opacity: 0.65;
  cursor: not-allowed;
}

.life-box--future .life-box-field {
  cursor: not-allowed;
}

.life-box--current {
  box-shadow: 0 0 0 2px var(--ml-accent);
}

.life-box--selected {
  box-shadow: 0 0 0 2px #198754;
  z-index: 2;
}

.life-box:not(.life-box--future):hover {
  box-shadow: 0 0 0 2px rgba(240, 93, 43, 0.45);
}

.life-box--event .life-box-field {
  text-align: left;
}

/* Móvil: mismas proporciones que weeks.ginatrapani.org (12px, casillas 2em) */
@media (max-width: 767.98px) {
  .my-life-page {
    font-size: 12px;
    line-height: 1.5;
  }

  .my-life-page .container-fluid {
    padding-top: 0.25rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .life-in-weeks {
    margin: 0 2%;
    padding: 0.25rem 0;
  }

  .life-boxes-flow {
    gap: 0;
  }

  .life-box {
    height: 2em;
    max-height: 2em;
    min-height: 2em;
    margin: 2px 1px;
    padding: 2px 5px;
    border-width: 2px;
  }

  .life-box--week.life-box--empty {
    width: 2em;
    min-width: 2em;
    max-width: 2em;
    padding: 2px;
  }

  .life-box-field {
    font-size: 12px;
    line-height: 1.3;
    padding: 2px 5px;
  }

  .life-box--week.life-box--empty .life-box-field {
    font-size: 12px;
    padding: 2px;
  }

  .life-box--birthday,
  .life-box--event {
    height: 2em;
    max-height: 2em;
    min-height: 2em;
  }

  .life-box--birthday .life-box-field,
  .life-box--event .life-box-field,
  .life-box--week:not(.life-box--empty) .life-box-field {
    font-size: 12px;
    padding: 2px 5px;
  }

  .life-box--week:not(.life-box--empty) {
    min-width: 0;
    max-width: none;
  }

  .decade-pill {
    font-size: 12px;
    padding: 0.2em 0.5em;
  }

  .my-life-topbar {
    font-size: 12px;
    padding: 0.25rem 0.35rem 0.3rem;
  }

  .my-life-topbar-title {
    font-size: 1.125rem;
  }

  .my-life-topbar--scrolled .my-life-topbar-title {
    font-size: 1rem;
  }

  .my-life-tab {
    font-size: 12px;
    padding: 0.1rem 0.35rem;
  }

  .my-life-save-btn {
    font-size: 12px;
  }

  .my-life-topbar-date-label {
    font-size: 12px;
  }

  .my-life-decade-link {
    font-size: 12px;
  }

  .my-life-topbar-select {
    font-size: 12px;
    min-height: 1.5rem;
  }

  .decade-anchor {
    scroll-margin-top: calc(var(--ml-topbar-h, 3.5rem) + 0.5rem);
  }
}

@media (min-width: 768px) {
  .life-box--birthday .life-box-field,
  .life-box--event .life-box-field {
    font-size: 1rem;
  }

  .life-box--week.life-box--empty {
    width: 2.15em;
    min-width: 2.15em;
    max-width: 2.15em;
    min-height: 2.15em;
  }
}
</style>
